import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
    calc_empty_error,
    calc_get_tickets,
    redirect_to_calc_page,
} from "../redux/actions";
import Cookies from "js-cookie";

export const GetTickets = () => {
    const dispatch = useDispatch();
    const fields = useSelector((state) => state.app.fields);
    const sizeType = useSelector((state) => state.app.sizeType);
    const emptyError = useSelector((state) => state.app.emptyError);
    let paid_weight = 0;
    let data = {};
    let emptyFields = false;
    let p_volume_weight = 0;
    let p_weight = 0;
    let temp = 0;
    let errors = [];
    if (fields.cityFrom.value === "") {
        emptyFields = true;
        errors.push("cityFrom");
    } else {
        data.cityFrom = fields.cityFrom.value;
    }
    if (fields.cityTo.value === "") {
        emptyFields = true;
        errors.push("cityTo");
    } else {
        data.cityTo = fields.cityTo.value;
    }
    if (fields.departureDate.value === "") {
        emptyFields = true;
        errors.push("departureDate");
    } else {
        data.departureDate =
            fields.departureDate.value.getDate() +
            "-" +
            (fields.departureDate.value.getMonth() + 1) +
            "-" +
            fields.departureDate.value.getFullYear();
    }
    if (fields.cargoName.value === "") {
        emptyFields = true;
        errors.push("cargoName");
    } else {
        data.cargoName = fields.cargoName.value;
    }
    data.sizeType = sizeType;
    if (sizeType === 1) {
        data.overallVolume = {};
        if (fields.overallVolume.places.value === "") {
            emptyFields = true;
            errors.push("overallVolume_places");
        } else {
            data.overallVolume.places = fields.overallVolume.places.value;
        }
        if (fields.overallVolume.weight.value === "") {
            emptyFields = true;
            errors.push("overallVolume_weight");
        } else {
            data.overallVolume.weight = fields.overallVolume.weight.value;
        }
        if (fields.overallVolume.volume.value === "") {
            emptyFields = true;
            errors.push("overallVolume_volume");
        } else {
            data.overallVolume.volume = fields.overallVolume.volume.value;
        }
        //temp = Math.ceil(Math.cbrt(parseFloat(fields.overallVolume.volume.value) / parseFloat(fields.overallVolume.places.value)) * 100);
        //p_volume_weight += parseFloat(temp / 100) * parseFloat(temp / 100) * parseFloat(temp / 100) * parseFloat(fields.overallVolume.places.value);
        p_volume_weight = +fields.overallVolume.volume.value;
        p_weight = +fields.overallVolume.weight.value;
    }
    if (sizeType === 2) {
        data.sizes = [];
        for (let i = 0; i < fields.sizes.length; i++) {
            if (
                fields.sizes[i].sizeLength.value === "" ||
                fields.sizes[i].sizeWidth.value === "" ||
                fields.sizes[i].sizeHeight.value === "" ||
                fields.sizes[i].sizeWeight.value === "" ||
                fields.sizes[i].sizeCounter.value === ""
            ) {
                emptyFields = true;
                errors.push("sizes");
            } else {
                data.sizes.push({
                    sizeLength: fields.sizes[i].sizeLength.value,
                    sizeWidth: fields.sizes[i].sizeWidth.value,
                    sizeHeight: fields.sizes[i].sizeHeight.value,
                    sizeWeight: fields.sizes[i].sizeWeight.value,
                    sizeCounter: fields.sizes[i].sizeCounter.value,
                });
                p_volume_weight +=
                    parseFloat(
                        parseInt(fields.sizes[i].sizeLength.value) / 100,
                    ) *
                    parseFloat(
                        parseInt(fields.sizes[i].sizeWidth.value) / 100,
                    ) *
                    parseFloat(
                        parseInt(fields.sizes[i].sizeHeight.value) / 100,
                    ) *
                    parseInt(fields.sizes[i].sizeCounter.value);
                p_weight +=
                    parseFloat(parseInt(fields.sizes[i].sizeWeight.value)) *
                    parseInt(fields.sizes[i].sizeCounter.value);
            }
        }
        if (data.sizes.length === 0) {
            emptyFields = true;
        }
    }
    if (p_weight > p_volume_weight * 167) {
        paid_weight = p_weight;
    } else {
        paid_weight = p_volume_weight * 167;
    }
    if (isNaN(paid_weight)) {
        paid_weight = 0;
    }
    if (errors.length > 0) {
    }
    const is_calc_page =
        window.location.href.indexOf("/calc/") > 0 ? true : false;
    let req = false;
    if (Cookies.get("calc_redirect") === "1") {
        req = true;
    }
    useEffect(() => {
        if (req && is_calc_page) {
            dispatch(calc_get_tickets(data));
        }
    }, [dispatch, data, req, is_calc_page]);

    if (emptyFields) {
        //return null
    }

    const handleCallManagerClick = (data, sizeType) => {
        console.log("Manager");
        let comment = "";
        comment += "Откуда: " + data.cityFrom.value + "\n";
        comment += "Куда: " + data.cityTo.value + "\n";
        comment += "Дата: " + new Date(data.departureDate.value).toLocaleDateString('ru-RU') + "\n";
        comment += "Наименование груза: " + data.cargoName.value + "\n";

        if (sizeType === 1) {
            comment += "Общий объем: \n";
            comment += "Кол-во мест: " + data.overallVolume.places.value + "\n";
            comment += "Вес груза: " + data.overallVolume.weight.value + "\n";
            comment += "Объем: " + data.overallVolume.volume.value + "\n";
        }
        if (sizeType === 2) {
            comment += "Указать габариты: \n";
            for (let i = 0; i < data.sizes.length; i++) {
                comment += "Указать габариты: \n";
                comment +=
                    fields.sizes[i].sizeLength.value +
                    "см x " +
                    fields.sizes[i].sizeWidth.value +
                    "см x " +
                    fields.sizes[i].sizeHeight.value +
                    "см | " +
                    fields.sizes[i].sizeWeight.value +
                    "кг x " +
                    fields.sizes[i].sizeCounter.value;
            }
        }
        const event = new CustomEvent("theme-popup-calc", { detail: comment });
        window.dispatchEvent(event);
    };

    return (
        <div className="front-calc__control">
            <div className="front-calc__paid_weight">
                <label>Оплачиваемый вес</label>
                <div className="front-calc__input">
                    {paid_weight.toFixed(2)} кг
                </div>
            </div>
            <div
                className="front-calc__submit btn btn__size_2 btn__orange"
                onClick={() => {
                    if (emptyFields) {
                        return dispatch(calc_empty_error(errors));
                    }

                    if (window.ym) {
                        // eslint-disable-next-line no-undef
                        ym(26965848, "reachGoal", "online-calc");
                    }
                    return handleCallManagerClick(fields, sizeType);
                }}
            >
                Оставить заявку
            </div>
            {emptyFields && emptyError && (
                <div className="front-calc__error">
                    Кажется, вы забыли что-то заполнить. Для расчета заполните
                    все данные.
                </div>
            )}
        </div>
    );
};
